import {styled} from "@mui/material/styles";
import {Typography, TypographyProps} from "@mui/material";

const EmptyListText = styled(Typography, {})<TypographyProps>(({theme}) => ({
  ...theme.typography.p3,
  color: theme.palette.grey[200],
}));

export default EmptyListText;
